import {generateFolderTeamMembershipFromTeam, getTeamByHashid} from './teams';

import {createResponseList} from '../utils';

import {RawFolderSerializedType, TeamSerializedType} from 'sweet-types';

let currentId = 1;

export const createFakeFolder = (
  name: string,
  hashid: string,
  teams: TeamSerializedType[],
  parent: null | string = null
): RawFolderSerializedType => ({
  id: ++currentId,
  content_type: 'folder',
  name,
  description: {
    content: '',
    images: [],
    files: [],
    content_type: 'folderdescription',
  },
  hashid,
  url: `/api/v1/folders/${currentId}/`,
  html_url: `/documents/?folder=${hashid}`,
  teams: teams.map((team) => ({
    id: team.id,
    type: 'basic_team',
  })),
  parent,
  team_memberships: teams.map((team) =>
    generateFolderTeamMembershipFromTeam(team)
  ),
  can_view: true,
  can_change: true,
  can_edit: true,
  can_delete: true,
});

export const folders_list_fixture = createResponseList([
  createFakeFolder('Customer Support', 'customer-support', [
    getTeamByHashid('team-1'),
  ]),
  createFakeFolder('Accounting Management', 'accounting-management', [
    getTeamByHashid('team-3'),
    getTeamByHashid('team-2'),
  ]),
]);

export const getFolderListFilteredByParent = (
  parent: null | string
): RawFolderSerializedType[] => {
  return folders_list_fixture.results.filter((f) => f.parent === parent);
};
